var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositivityBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Positivity "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 4.60667L9.75333 7.44L12.8867 7.91333C13.1933 7.96 13.3133 8.33333 13.0933 8.54667L10.8333 10.7733L11.3533 13.9C11.4067 14.2 11.0867 14.4333 10.8133 14.2933L8 12.8333L5.18667 14.2933C4.91333 14.4333 4.6 14.2067 4.64667 13.9L5.16667 10.7733L2.90667 8.54667C2.68667 8.33333 2.80667 7.96 3.11333 7.91333L6.24667 7.44L7.66667 4.60667C7.80667 4.33333 8.19333 4.33333 8.33333 4.60667Z",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8 1.02V2.50667",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.22667 4.08L3.28 5.13333",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.7733 4.08L12.72 5.13333",
    stroke: "#0D70DC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositivityBlue);
export default __webpack_public_path__ + "static/media/positivity-blue.5007f1013b61fc5d7e4c738d6fc2c638.svg";
export { ForwardRef as ReactComponent };